module.exports = __webpack_public_path__ + "static/media/3.ed3c00e9.jpg";